// Keep local requests and navigation on the browser's loopback hostname so
// SameSite session cookies work with both localhost and 127.0.0.1.
export function browserUrl(value: string): string {
  const url = new URL(value.trim());
  const isLoopback = (host: string) => host === "localhost" || host === "127.0.0.1";
  if (
    import.meta.env.DEV &&
    typeof window !== "undefined" &&
    isLoopback(window.location.hostname) &&
    isLoopback(url.hostname)
  ) {
    url.hostname = window.location.hostname;
  }
  return url.toString().replace(/\/$/, "");
}
